<template>
  <v-card flat class="pa-5" :color="color" min-height="100%">
    <slot></slot>
  </v-card>
</template>

<script lang="ts" setup>
const { color } = defineProps<{ color?: string }>()
</script>
